/**
 * /user/profile ↔ main's GetSelfProfile / UpdateSelfProfile.
 * Identity is the session; the body never names accountnumber / unique_ID.
 *
 * On the port the legacy bridge answers both from `/me` (api2/bridgeMap.js
 * `AccountUser.*SelfProfile`, mapped by api2/selfProfileShape.js), for the
 * access token's subject. A refusal keeps the API's `code` and per-field
 * `errors`, so the page can say why — above all `mfa_destination_managed_at_idp`,
 * the phone that receives sign-in codes, which is not changed here.
 */
import axios from 'axios';
import { CURR_API } from '@/constants/apis';
import { normalizeSelfProfile, buildSelfProfileWritePayload } from '@/utils/selfProfileForm';

const WEBHOOK = `${CURR_API}/tswebhook.php`;

function refused(data, fallback) {
  return {
    ok: false,
    status: (data && data.status) || 'Failure',
    code: (data && data.code) || null,
    message: (data && data.message) || fallback,
    errors: (data && data.errors) || null,
    profile: null,
  };
}

export async function getSelfProfile({ client } = {}) {
  const http = client || axios;
  const { data } = await http.post(WEBHOOK, {
    AccountUser: { API_Meth: 'GetSelfProfile' },
  });
  if (!data || data.status !== 'Successful' || !data.data) {
    return refused(data, 'Could not load profile');
  }
  return { ok: true, profile: normalizeSelfProfile(data.data) };
}

export async function updateSelfProfile(profileForm, { client } = {}) {
  const http = client || axios;
  const { data } = await http.post(WEBHOOK, {
    AccountUser: {
      API_Meth: 'UpdateSelfProfile',
      profile: buildSelfProfileWritePayload(profileForm),
    },
  });
  if (!data || data.status !== 'Successful' || !data.data) {
    return refused(data, 'Could not save profile');
  }
  return { ok: true, profile: normalizeSelfProfile(data.data) };
}
